module.exports = __webpack_public_path__ + "static/media/Just So Happens.ef24521a.jpg";